<div class="supply-catalog-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Catalog Intelligence</p>
      <h2>Supply Catalog</h2>
      <p class="subtitle">See which product types are active, dormant, or underused so the supply catalog stays commercially useful.</p>
    </div>
    <button mat-stroked-button (click)="loadCatalog()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card primary">
      <span>Catalog Types</span>
      <strong>{{ productTypes.length }}</strong>
      <small>Total configured product groups</small>
    </article>
    <article class="stat-card success">
      <span>Active Types</span>
      <strong>{{ activeTypes.length }}</strong>
      <small>Types with meaningful dispatch movement</small>
    </article>
    <article class="stat-card warning">
      <span>Dormant / Empty</span>
      <strong>{{ dormantTypes.length }}</strong>
      <small>Needs cleanup or activation</small>
    </article>
    <article class="stat-card accent">
      <span>Tracked Items</span>
      <strong>{{ itemUtilization.length }}</strong>
      <small>Items with recent dispatch activity</small>
    </article>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Catalog Health</h3>
        <span>By product type</span>
      </div>
      <div class="health-list" *ngIf="catalogHealth.length; else noCatalog">
        <div class="health-row" *ngFor="let row of catalogHealth">
          <div>
            <strong>{{ row.name }}</strong>
            <small>{{ row.items }} items · {{ row.dispatches }} dispatches</small>
          </div>
          <span class="status" [ngClass]="row.status.toLowerCase()">{{ row.status }}</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Item Utilization</h3>
        <span>Most-used items</span>
      </div>
      <div class="health-list" *ngIf="itemUtilization.length; else noCatalog">
        <div class="health-row" *ngFor="let row of itemUtilization">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }} dispatches</span>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noCatalog>
  <p class="muted">No catalog usage data available yet.</p>
</ng-template>
